import { render, staticRenderFns } from "./WaterRadiatorDescription.vue?vue&type=template&id=3b0eb6f6&scoped=true"
import script from "./WaterRadiatorDescription.vue?vue&type=script&lang=ts"
export * from "./WaterRadiatorDescription.vue?vue&type=script&lang=ts"
import style0 from "./WaterRadiatorDescription.vue?vue&type=style&index=0&id=3b0eb6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0eb6f6",
  null
  
)

export default component.exports